import NewsPage from '../news_page';
import categoryPageStateManager from '../category_page_state_manager';

export default function(store) {
  return {
    path: '/news/:page?',
    component: NewsPage,
    strict: true,
    exact: true,
    loadData: categoryPageStateManager(store, 'news')
  };
}
